/*--############################################################################
# Filename : MST01_033INS.vue                                                  
# Description : 마스터관리 > 메뉴 마스터 > 메뉴코드등록                        
# Date :2025-05-14                                                             
# Author : 권맑음                     
################################################################################*/
<template>
  <div class="flex items-center justify-center h-full w-full bg-gray-100">
    <div
      class="flex flex-col items-center justify-center p-8 bg-white shadow-lg rounded-lg w-[1000px] h-[800px]">
      <h1 class="text-4xl font-semibold text-gray-800 mb-4">
        이 페이지는 존재하지 않습니다!
      </h1>
      <p class="text-lg text-gray-600 mb-6">
        요청하신 페이지를 찾을 수 없습니다.
      </p>

      <!-- Decorative Image -->
      <div
        class="w-64 h-64 bg-gray-100 rounded-full flex items-center justify-center mb-6">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-32 w-32 text-gray-300"
          viewBox="0 0 20 20"
          fill="currentColor">
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.707a1 1 0 00-1.414-1.414L10 9.586 7.707 7.293a1 1 0 10-1.414 1.414L8.586 11l-2.293 2.293a1 1 0 001.414 1.414L10 12.414l2.293 2.293a1 1 0 001.414-1.414L11.414 11l2.293-2.293z"
            clip-rule="evenodd" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped>
/* 여기서 스타일을 더 추가할 수 있습니다. */
</style>
